import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { DialogService, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { DialogTemplate } from '@core/models/models';
import { DummyService } from '@core/services/apis/dummy.service';
import { ScreenTitleConfigService } from '@core/services/apis/screen-title-config.service';
import { MultipleSpinnerService } from '@core/services/common/multiple-spinner.service';
import { TitleTagRequest } from '@core/models/request/title-tag-request.model';
import { TITLE_SETTINGS, TOOLTIP_DIALOG} from '@core/constants';
import { TitleSettingDialogLogService } from '@core/services/saucer-logs/title-setting-dialog-log.service';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
@Component({
  selector: 'caremoni-title-yotei-dialog',
  templateUrl: './title-yotei-dialog.component.html',
  styleUrls: ['./title-yotei-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class TitleYoteiDialogComponent implements OnInit {
  @Input() yoteis: any[]=[]; 

  @Output() onClosedYoteiHandler = new EventEmitter();
  @Output() onSavedYoteiDialog =new EventEmitter<any>();


  dialogTemplate: DialogTemplate = new DialogTemplate();
  showTagDialog:boolean = false;
  kbnTagLst: any;
  kbnTagSelected: any;

  ttlTagLst: any;
  ttlTagSelected: any;

  ttlNameLst: any;
  ttlNameSelected: any;

  iTagLst: any;
  iTagSelected: any;

  iTagNameLst: any;
  iTagNameSelected: any;

  itagChecked: boolean = false;

  listTags: any[] = [];
  isShowKbnTagLst: boolean = false;
  kbnTagLstAll: any;
  kbnTagAllSelected: any[] = [];
  titleLst: any[] = [];
  kbnTagPick: any[] = [];
  instruction:string="ケアモニに表示する利用者予定を選択してください";
  toolTip = TOOLTIP_DIALOG
  dockbn:string = '';
  notekbn:string = '';
  constructor(
    public config: DynamicDialogConfig,
    public dummyService: DummyService,
    public screenTitleConfigService:ScreenTitleConfigService,
    private mutiLoadingService: MultipleSpinnerService,
    private dialogService: DialogService,
    private titleSettingDialogLogService: TitleSettingDialogLogService,
  ) {
    }

  async ngOnInit(): Promise<void> {
    this.itagChecked=true;
    this.dialogTemplate.header = "表示タイトル設定";
    this.dialogTemplate.style = { 'width': '90%' };
    this.dialogTemplate.closable = false;

    if(this.yoteis!=null )
      this.addTagsYoteis()
      this.dockbn="0";
      this.notekbn="4";
    await this.bindData();
    this.titleSettingDialogLogService.view();
    }
  async bindData(){
    this.mutiLoadingService.show();
    this.titleLst.push("利用者予定");
    this.kbnTagLst = (await this.screenTitleConfigService.getKbntagsSettings(this.titleLst)).result;
    this.mutiLoadingService.hide();
    //Default data
    this.kbnTagSelected = this.kbnTagLst[0];

    this.ttlTagLst = this.kbnTagLst[0].ttlTagLst;
    this.ttlTagSelected = this.ttlTagLst[0];

    this.ttlNameLst = this.ttlTagLst[0].ttlNameLst;
    this.ttlNameSelected = this.ttlNameLst[0];

    this.iTagLst = this.ttlTagLst[0].iTagLst;
    this.iTagSelected = this.iTagLst[0];

    this.iTagNameLst = this.iTagSelected.iTagNameLst;
    this.iTagNameSelected = this.iTagNameLst[0];

    //Set active
    this.kbnTagLst[0].selected = 'selected';
    this.ttlTagLst[0].selected = 'selected';
    this.ttlNameLst[0].selected = 'selected';
    this.iTagLst[0].selected = 'selected';
    this.iTagNameLst[0].selected = 'selected';
  }

  selectKbnTag(kbnTagItem: any){ 
    this.kbnTagSelected = kbnTagItem;
    this.kbnTagLst.forEach((kbnTag: any) => {
      kbnTag.selected = kbnTag === kbnTagItem ? 'selected' : '';
    });

    this.ttlTagLst = kbnTagItem.ttlTagLst ?? [];
    this.ttlTagSelected = this.ttlTagLst[0];
    if (this.ttlTagSelected) {
      this.selectTtlTag(this.ttlTagSelected);
    } else {
      this.ttlNameLst = [];
      this.ttlNameSelected = undefined;
      this.iTagLst = [];
      this.iTagSelected = undefined;
      this.iTagNameLst = [];
      this.iTagNameSelected = undefined;
    }
  }
  selectTtlTag(ttlTagItem: any){
    this.ttlTagLst.forEach((ttlTag: any) =>{
      ttlTag.selected = '';
      if(ttlTag.ttlTag == ttlTagItem.ttlTag) ttlTag.selected = 'selected';
    })
    this.ttlTagSelected = ttlTagItem;

    this.ttlNameLst = ttlTagItem.ttlNameLst;
    this.ttlNameSelected = this.ttlNameLst[0];
    this.ttlNameLst.forEach((ttlName: any) =>{ttlName.selected = '';})
    this.ttlNameLst[0].selected = 'selected';

    this.iTagLst = ttlTagItem.iTagLst;
    this.iTagSelected = this.iTagLst[0];
    this.iTagLst.forEach((iTag: any) => { iTag.selected = '';})
    this.iTagLst[0].selected = 'selected';

    this.iTagNameLst = this.iTagLst[0].iTagNameLst;
    this.iTagNameLst.forEach((iTagName: any) =>{iTagName.selected = ''})
    this.iTagNameSelected = this.iTagNameLst[0];
    this.iTagNameLst[0].selected = 'selected';
    
  }
  selectTtlName(ttlNameItem: any){
    this.ttlNameLst.forEach((ttlName: any) =>{
      ttlName.selected = '';
      if(ttlName.ttlName == ttlNameItem.ttlName) ttlName.selected = 'selected'; 
    })
    this.ttlNameSelected = ttlNameItem;
  }
  selectItag(iTagItem: any){
    this.iTagLst.forEach((iTag: any) =>{
      iTag.selected = '';
      if(iTag.iTag == iTagItem.iTag) iTag.selected = 'selected'; 
    })
    this.iTagSelected = iTagItem;
    this.iTagNameLst = iTagItem.iTagNameLst;
    this.iTagNameLst.forEach((iTagName: any) =>{ iTagName.selected = '';})
    this.iTagNameLst[0].selected = 'selected'; 
  }
  secletItagName(iTagNameItem: any){
    this.iTagNameSelected = iTagNameItem;
    this.iTagNameLst.forEach((iTagName: any) => {
      iTagName.selected = '';
      if(iTagName.iTagName == iTagNameItem.iTagName) iTagName.selected = 'selected';
    })
  }
  isShowTagLst(event: any){ this.itagChecked = event; }
  pickTag(){
    if (!this.kbnTagSelected?.kbnTag || !this.ttlTagSelected?.ttlTag || !this.ttlNameSelected?.ttlName) return;

    let tagSelect = {
      kbnTtlTag: this.kbnTagSelected.kbnTag + '.' + this.ttlTagSelected.ttlTag.slice(1),
      ttlName: this.ttlNameSelected.ttlName,
      iTag: '*',
      iTagName: this.iTagNameSelected.iTagName,
    }
    if(!this.itagChecked) tagSelect.iTag = this.iTagSelected.iTag;
    const exists = this.listTags.some(x =>
      x.kbnTtlTag === tagSelect.kbnTtlTag &&
      x.iTag === tagSelect.iTag
    );

    if (!exists) {
      this.listTags.push(tagSelect);
      this.titleSettingDialogLogService.titleAddedorDeleted(tagSelect,'addTitle');
    } else {
    }
  }
  removeTag(tagPicked: any){
    this.listTags = this.listTags.filter((tag: any) => (tag.kbnTtlTag != tagPicked.kbnTtlTag));
    this.titleSettingDialogLogService.titleAddedorDeleted(tagPicked,'deleteTitle'); 
  }
  closeModal(){
    this.onClosedYoteiHandler.emit();
    this.titleSettingDialogLogService.close();
  }
  async saveYotei(){
    const request:TitleTagRequest ={
      displayName: "利用者予定",
      tags: this.listTags,
      dockbn:this.dockbn,
      notekbn:this.notekbn
    }
    var response = await this.screenTitleConfigService.getYoteisByTags(request);
    if(response.status==200){
      var titles = response.result;
      const mappedList = titles.map((x: any, index: number) => ({
        id: index + 1,
        name: x.ttlkbnnm + '＞' + x.ttlnm,
        ttlkbn: x.ttlkbn,
        ttlcd: x.ttlcd,
        tag:x.tag
      }));
      this.onSavedYoteiDialog.emit(mappedList);
    }

  }
  async showKbnTagLst(){ 
    this.mutiLoadingService.show();
    this.kbnTagLstAll = (await this.screenTitleConfigService.getKbnTags()).result || [];

    const existingKbnTags = this.kbnTagLst.map(((kbnTagItem:any)=>kbnTagItem.kbnTag))
    this.kbnTagLstAll=this.kbnTagLstAll.filter((kbnTagItem:any)=>!existingKbnTags.includes(kbnTagItem.kbnTag))

    this.kbnTagAllSelected = [];
    this.mutiLoadingService.hide();
    this.isShowKbnTagLst = true;
  }
  selectKbnTagLst(kbnTagItem: any){
    this.kbnTagLstAll.forEach((kbnTag: any) =>{if(kbnTag.kbnTag == kbnTagItem.kbnTag) kbnTag.kbnselected = 'kbnselected';})
    let kbnSelect = this.checkKbnTagLstSelected(kbnTagItem.kbnTag, this.kbnTagAllSelected);
    if(!kbnSelect) this.kbnTagAllSelected.push(kbnTagItem);
  }
  checkKbnTagLstSelected(kbnTag: any, kbnTagLst: any[]): boolean {
    return kbnTagLst.some((tag: any) => tag.kbnTag === kbnTag);
  }
  closeKbnTagLst(){ 
    const ref = this.dialogService.open(ConfirmDialogComponent, {
      width: '25%',
      height: '30%',
      data: {
        message: TITLE_SETTINGS.CANCEL_DIALOG_TITLE,
        isOkCancel: true
      }
    })
    ref.onClose.subscribe(async (result) => { if(result === 'ok'){ this.isShowKbnTagLst = false } });
   }
  async aceptKbnTagLst(){
    this.kbnTagAllSelected.forEach((kbnTag: any) =>{ this.kbnTagPick.push(kbnTag.kbnTag); })
    const kbnTags = (await this.screenTitleConfigService.getTitletagSettingsByKbnTags(this.kbnTagPick)).result;
    kbnTags.forEach((kbnTag: any) => { this.kbnTagLst.push(kbnTag); });
    this.isShowKbnTagLst = false;
  }
  removeKbnTagLst(kbnTagSelectedItem: any){
    this.kbnTagAllSelected = this.kbnTagAllSelected.filter((kbnTag: any) => (kbnTag.kbnTag != kbnTagSelectedItem.kbnTag));
    this.kbnTagLstAll.forEach((kbnTag: any) => { if(kbnTag.kbnTag == kbnTagSelectedItem.kbnTag) kbnTag.kbnselected = ''; })
  }

  async setDefaultByColName() {
    const oldTags = this.titleSettingDialogLogService.getTitleTagSnapshot(this.listTags);
    const ref = this.dialogService.open(ConfirmDialogComponent, {
      width: '25%',
      height: '30%',
      data: {
        message: TITLE_SETTINGS.TITLE_DEFAULT_DIALOG,
        isOkCancel: true
      }
    })

    ref.onClose.subscribe(async (result) => {
      if (result === 'ok') {
        this.mutiLoadingService.show();
        var response = await this.screenTitleConfigService.genYoteiToDefaultByColName("利用者予定")
        if (response.status == 200) {
          this.listTags=[]
          var yoteis = response?.result;
          if (yoteis != null){
            this.yoteis = yoteis;
            this.addTagsYoteis()
          }
          this.titleSettingDialogLogService.defaultRestored(
            oldTags,
            this.titleSettingDialogLogService.getTitleTagSnapshot(this.listTags)
          );
        }
        this.mutiLoadingService.hide();
      }
    });
  }

  async showDialogCancel() {
    const ref = this.dialogService.open(ConfirmDialogComponent, {
      width: '25%',
      height: '30%',
      data: {
        message: TITLE_SETTINGS.CANCEL_DIALOG,
        isOkCancel: true
      }
    })

    ref.onClose.subscribe(async (result) => {
      if (result === 'ok') {
          this.onClosedYoteiHandler.emit();
          this.titleSettingDialogLogService.close();
      }
    });
  }
  onClosedTagDialog(){
    this.showTagDialog = false;
  }

  onShowTagDialog(){
    this.showTagDialog = true;
    this.titleSettingDialogLogService.showTagInfo();
  }

  private addTagsYoteis(): void {
    this.yoteis.forEach((element: any) => {
      if (element.tag) {
        var item = JSON.parse(element.tag)
        const exists = this.listTags.some(x =>
          x.kbnTtlTag === item.kbnTtlTag &&
          x.iTag === item.iTag
        );
        if (!exists)
          this.listTags.push(
            {
              kbnTtlTag: item.kbnTtlTag,
              ttlName: item.ttlName,
              iTag: item.iTag,
              iTagName: item.iTagName
            }
          );
      }
    });
  }

}
